// import $ from 'jquery';
// import Anchor from '../Components/_Anchor.js';
import '../Components/_Slider.js';
import '../Components/_Matchheight.js';
import '../Components/_Accor.js';
import '../Components/_Tab.js';
import '../Components/_Loading.js';
import '../Components/_Other.js';
